/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from 'axios'
import router from '@/router'
import { baseApiUrl } from '../../global'
export default {

  async fetchTotalGoldOrder({ commit }, payload) {

    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/goldOrder/getTotalGoldOrder`
      )
      payload.loading.close()
      commit('SET_TOTAL_GOLD_ORDER', response.data)
    } catch (error) {
      console.log(error)
    }finally{
      payload.loading.close()
    }
  },

  async fetchGoldOrder({ commit }, payload) {
    
    
    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/goldOrder/getGoldOrder?type=${payload.type}`
      )
      payload.loading.close()
      commit('SET_GOLD_ORDER', response.data)
    } catch (error) {
      console.log(error)
    }
  },


  async addNewGoldOrder({ commit }, payload) {
 
    try {
      payload.loading()
      let res = await axios.post(`${baseApiUrl}/goldOrder/save`, payload.order)
      payload.order.idGoldOrder = res.data
      delete payload.order.itemsOrder
      commit('ADD_NEW_GOLD_ORDER', payload.order)
      payload.loading.close()
      payload.notify({
        title: "Salvo",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
    router.push(`/ouro`).catch(() => { });
  },



  async removeGoldOrder({ commit }, payload) {
    let idGoldOrder = payload.idOrder
    try {
      payload.loading()
      await axios.post(`${baseApiUrl}/goldOrder/remove`, { idGoldOrder })
      payload.loading.close()
      commit('REMOVE_GOLD_ORDER', idGoldOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }

  },


  async updateGoldOrder({ commit }, payload) {

    try {
      payload.loading()
      await axios.post(`${baseApiUrl}/goldOrder/update`, payload.order)
      delete payload.order.itemsOrder
      commit('UPDATE_GOLD_ORDER', payload.order)
      payload.loading.close()
      payload.notify({
        title: "Atualizado",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "primary"
      })
    } catch (error) {
      //console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
    router.push(`/ouro`).catch(err => { });
  },

  async trashGoldOrder({ commit }, payload) {
    let idGoldOrder = payload.idOrder
    
    try {
      payload.loading() 
      await axios.post(
        `${baseApiUrl}/goldOrder/trash`,{ idGoldOrder }
      )
      payload.loading.close()
      commit('REMOVE_GOLD_ORDER', idGoldOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
  },
}
